import { render, staticRenderFns } from "./estadisticas-cliente-articulos.vue?vue&type=template&id=4193f7e5&scoped=true&"
import script from "./estadisticas-cliente-articulos.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-cliente-articulos.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas-cliente-articulos.vue?vue&type=style&index=0&id=4193f7e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4193f7e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VList,VListItem,VProgressCircular,VRow,VSpacer})
